export const SETTING_APPROVAL_BASE_QUERY_KEY = 'setting-approval';

export const settingApprovalApiQueryKeys = {
  preview: (token: string) => [SETTING_APPROVAL_BASE_QUERY_KEY, token] as const,
};
